<template>
  <div class="serviceDetails">
    <template v-if="ifShow">          
      <div class="banner" id="base_info">
        <div class="w" style="position: relative">
          <div class="ban_l">
            <div class="tit_p">
              当前位置：<span @click="returnFn">服务大厅</span>
              <img src="../../assets/icon/icon-right.png" alt="" />
              {{serviceDetails.serviceManage.serviceManageName}}
            </div>
            <div class="tit">{{serviceDetails.serviceManage.serviceManageName}}</div>
            <div class="desc">{{serviceDetails.serviceManage.description}}</div>
            <div class="flex">
              <div class="bon_col flex" v-if="serviceDetails.serviceManage.isApply">
                <div class="handle" @click="gotoWork">
                  <img src="../../assets/icon/icon-handle.png" alt="" /> 线上办理
                </div>
                <!-- <div class="flex" @click="addColl">
                  <img
                    src="../../assets/icon/icon-collection.png"
                    alt=""
                  />加入收藏
                </div>
                <div class="flex">
                  <img src="../../assets/icon/icon-evaluate.png" alt="" />我要评价
                </div> -->
              </div>
              <!-- <div class="rate">
                <span>满意度</span><a-rate :default-value="4" disabled />
                <div class="flex">
                  <div style="margin-right: 2%"><span>热度值：</span>{{serviceDetails.serviceManage.heatValue}}</div>
                  <div><span>收藏量：</span>{{serviceDetails.serviceManage.collectValue}}</div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="ban_r"></div>
        </div>
      </div>
      <a-affix id="myDiv" :offset-top="138" v-if="isAffixVisible">
        <div class="affix_box flex">
          <div class="flex w">
            <div class="tit">{{serviceDetails.serviceManage.serviceManageName}}</div>
              <div class="handle" v-if="serviceDetails.serviceManage.isApply" @click="gotoWork">
                <img src="../../assets/icon/icon-handle.png" alt="" /> 线上办理
              </div>
          </div>
        </div>
      </a-affix>
      <!-- 描点栏 -->
      <a-anchor :target-offset="targetOffset" class="anchor_box">
       <a-anchor-link href="#base_info" title="基本信息" />
       <!-- <a-anchor-link href="#service_content" title="服务内容" /> -->
       <a-anchor-link href="#process" title="服务流程" />
       <a-anchor-link href="#institutionFileVo" title="制度文件" />
       <a-anchor-link href="#file" title="相关材料" />
     </a-anchor>
     <div class="table_bg">
       <img src="../../assets/detail-bg-img.png" alt="">
      </div>
      <!-- 表格内容 -->
      <div class="w">
        <div class="table_out">
          <div class="flex" style="margin-bottom: 24px;">
            <div class="con_tit">基本信息</div>
            <div class="tag_box flex">
              <div class="green_tag" v-if="serviceDetails.serviceManage.priority == 1">上新</div>
              <div class="yellow_tag" v-if="serviceDetails.serviceManage.priority == 2">推荐</div>
              <!-- <div v-if="serviceDetails.serviceManage.priority == 3">置顶</div> -->
              <div class="red_tag" v-if="serviceDetails.serviceManage.serviceTimeLimit.length>0">限时</div>
            </div>
          </div>
          <div class="flex table_content" style="align-items: normal;">
            <div class="table_bd">
              <div class="flex table_line">
                <div class="flex table_box">
                  <div class="table_label">事项名称</div>
                  <div class="table_value">{{serviceDetails.serviceManage.serviceManageName}}</div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">主管部门</div>
                  <div class="table_value">{{serviceDetails.serviceManage.departmentName}}</div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">服务对象</div>
                  <div class="table_value">
                    <span v-for="item in serviceDetails.serviceManage.targetsNameList" :key="item">{{item}}&nbsp;</span>
                    </div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">服务时间</div>
                  <div class="table_value">法定工作日{{serviceDetails.serviceManage.serviceTime}}</div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">服务地点</div>
                  <div class="table_value">{{serviceDetails.serviceManage.address||'--'}}</div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">服务热线</div>
                  <div class="table_value">{{serviceDetails.serviceManage.hotLine||'--'}}</div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">服务方式</div>
                  <div class="table_value">{{serviceDetails.serviceManage.way==1?'线上':serviceDetails.serviceManage.way==0?'线上&线下':serviceDetails.serviceManage.way==2?'线下':'--'}}</div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">跑腿次数</div>
                  <div class="table_value">
                    <div v-if="serviceDetails.serviceManage.runNum==0">无需跑腿</div>
                    <div v-else>{{ serviceDetails.serviceManage.runNum }}次</div>
                  </div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">服务终端</div>
                  <div class="table_value">
                    <div v-if="serviceDetails.serviceManage.isApply != 0" class="flex" style="justify-content: center;">
                      <div class="flex" v-if="serviceDetails.serviceManage.terminal != 1"><img src="../../assets/icon-mobile-outline.png" alt="">手机</div>
                      <div class="flex" :style="serviceDetails.serviceManage.terminal != 1?'margin-left: 16px;':''" v-if="serviceDetails.serviceManage.terminal != 2"><img src="../../assets/icon-pc-outline.png" alt="">电脑</div>
                    </div>
                    <div v-else>无</div>
                  </div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">收费标准</div>
                  <div class="table_value">{{serviceDetails.serviceManage.charge}}</div>
                </div>
  
                <!-- <div class="flex table_box">
                  <div class="table_label">匿名服务：</div>
                  <div class="table_value">{{serviceDetails.serviceManage.anon==0?'匿名':serviceDetails.serviceManage.anon==1?'不匿名':''}}</div>
                </div>
               
                <div class="flex table_box">
                  <div class="table_label">服务时限：</div>
                  <div class="table_value">
                    <div>{{ serviceDetails.serviceManage.serviceTimeLimit }}</div>
                  </div>
                </div>
                <div class="flex table_box">
                  <div class="table_label">跑腿次数：</div>
                  <div class="table_value">
                    <div v-if="serviceDetails.serviceManage.runNum==0">无需跑腿</div>
                    <div v-else>{{ serviceDetails.serviceManage.runNum }}次</div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="table_rt">
              <div class="rt_box">
                <div class="rt_title">服务统计</div>
                <div class="li_box flex">
                  <img src="../../assets/icon/icon-run-number.png" alt="">
                  <span>跑动次数</span>
                  <span class="number">{{serviceDetails.serviceManage.runNum||0}}</span>
                  <span>次</span>
                </div>
                <div class="li_box flex">
                  <img src="../../assets/icon/icon-file.png" alt="">
                  <span>递交材料</span>
                  <span class="number">{{serviceDetails.serviceManage.materialNum}}</span>
                  <span>份</span>
                </div>
                <div class="li_box flex">
                  <img src="../../assets/icon/icon-step.png" alt="">
                  <span>经历环节</span>
                  <span class="number">{{serviceDetails.serviceProcessVo.process.length}}</span>
                  <span>个</span>
                </div>
              </div>
              <div class="rt_box">
                <div class="rt_title">热度分析</div>
                <div class="li_box flex">
                  <img src="../../assets/icon/icon-hot.png" alt="">
                  <span>热度值</span>
                  <span class="number">{{serviceDetails.serviceManage.heatValue}}</span>
                </div>
                <div class="li_box flex">
                  <img src="../../assets/icon/icon-collect.png" alt="">
                  <span>收藏量</span>
                  <span class="number">{{serviceDetails.serviceManage.collectValue}}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- tab栏 -->
           <div class="flex tabs">
            <div
              :class="['bon', index == tabIdx ? 'click_sty' : '']"
              v-for="(item, index) in tabList"
              :key="index"
              :id="item.id"
              @click="tabChange(index)"
            >
              {{ item.name }}
            </div>
           </div>

           <template v-if="tabIdx==0">
            <div class="pres">
              <div class="text-container" style="text-align: left;" v-html="serviceDetails.serviceProcessVo.content"></div>
            </div>
            <div class="step_ul" v-if="serviceDetails.serviceProcessVo.process.length>0">
              <div class="step_li" v-for="(item,idx) in serviceDetails.serviceProcessVo.process" :key="idx">
                <div class="flex">
                  <div>
                    <div class="order">{{item.step}}</div>
                    <img v-if="idx+1 != serviceDetails.serviceProcessVo.process.length" src="../../assets/icon/icon_arrow_down.png" alt="">
                  </div>
                  <div class="li_r">
                    <div class="li_title">{{item.stepContent}}</div>
                    <div class="remark">{{item.stepRemark}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="precautions" v-if="serviceDetails.serviceProcessVo.askQuestion!=''">
              <div>注意事项</div>
              <div class="text-container" v-html="serviceDetails.serviceProcessVo.askQuestion"></div>
            </div>
           </template>
           <template v-if="tabIdx==1">
            <div class="file_class flex" v-for="item in serviceDetails.serviceMaterialVo" :key="item.id" >
              <div class="flex">
                <img style="margin-right: 16px;" src="../../assets/icon/icon-word.png" alt="">
                <div>{{ item.name }}.{{ item.suffix }}</div>
              </div>
              <div class="flex" v-if="item.materialId">
                <a @click="gotoFile(item,1)" style="color: #1890ff;margin-right: 16px;">预览</a>
                <a class="flex" :href="imgPrefix+item.materialId" :download="item.name">
                  <div>下载</div>
                  <img src="../../assets/icon/icon-down-img.png" alt="">
                </a>
              </div>
            </div>
            <div style="text-align: left;" v-if="serviceDetails.serviceMaterialVo.length==0">暂无</div>
           </template>

           <template v-if="tabIdx==2">
            <div class="file_class flex" v-for="item in serviceDetails.institutionFileVo" :key="item.wid" >
              <div class="flex">
                <img style="margin-right: 16px;" src="../../assets/icon/icon-word.png" alt="">
                <div>{{ item.name }}</div>
              </div>
              <div class="flex" v-if="item.wid">
                <a @click="gotoFile(item,2)" style="color: #1890ff;margin-right: 16px;">预览</a>
                <a class="flex"  :href="imgPrefix+item.wid" :download="item.title">
                  <div>下载</div>
                  <img src="../../assets/icon/icon-down-img.png" alt="">
                </a>
              </div>
            </div>
            <!-- <a v-for="item in serviceDetails.institutionFileVo" :key="item.wid" @click="gotoFile(item)" class="file_class" >
              {{ item.title }}
            </a> -->
           </template>
        </div>
       
      </div>
    </template>
    <template v-else>
      <a-spin style="height: 100vh;" />
    </template>
  </div>
</template>

<script>

import {findServiceManageDetailByIdApi} from '@/api/index'
import imgPrefix from '../../../utils/imgPrefix';
export default{
  data() {
    return {
      serviceDetails:{
        serviceProcessVo:{process:[]}
      },
      top: 10,
      ifShow:false,
      targetOffset: undefined,
      manageId:'',
      imgPrefix,
      tabList: [
        {id:'process', name: '办理流程'},
        {id:'制度文件', name: '办理材料'},
        {id:'institutionFileVo', name: '制度文件'},
      ],
      tabIdx: 0,
      fileTypeList:[
        {type:'word',imgUrl:require('../../assets/icon/icon-word.png')},
      ],
      isAffixVisible: false,
      lastScrollTop: 0,
      content: '服务内容\n注意事项'
    };
  },
  computed: {},
  watch: {},
  created() {
    // console.log(this.$route.query,'-----');    
    this.manageId = this.$route.query.serviceManageId;
    this.findServiceManageDetailById()
  },
  mounted() {
    // 更改描点到浏览器顶部的位置
    this.targetOffset = window.innerHeight / 3;
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    tabChange(idx){
      this.tabIdx = idx;
    },
    handleScroll() {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (!this.isAffixVisible && currentScrollTop > 300 && currentScrollTop > this.lastScrollTop) {
        this.isAffixVisible = true;
      } else if (this.isAffixVisible && currentScrollTop <= 300) {
        this.isAffixVisible = false;
      }
      this.lastScrollTop = currentScrollTop;
    },
    // 处理特殊符号
    getStr(str){
      str = str.replace(/&lt;|&gt;|&amp;/g, match => {
        switch(match) {
            case "&lt;": return "<";
            case "&gt;": return ">";
            case "&amp;": return "&";
            default: return match; // 默认情况下保持不变
        }
      });
      return str
    },
    // 获取详情
    findServiceManageDetailById(){
      findServiceManageDetailByIdApi(this.manageId).then(res => {
        console.log(res);
        // res.serviceManage.targets = res.serviceManage.targets?.split(',');
        if(res.serviceProcessVo.content){
          res.serviceProcessVo.content = this.getStr(res.serviceProcessVo.content)
        }
        if(res.serviceProcessVo.content){
          res.serviceProcessVo.content = this.getStr(res.serviceProcessVo.content)
        }
        this.serviceDetails = res;
        this.ifShow = true;
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 办理
    gotoWork(){
      if(this.serviceDetails.serviceManage.isApply){
        window.open(this.serviceDetails.serviceManage.pcUrl);
      }
    },
    // 收藏
    addColl(){
      window.open('https://portal.ly-sky.com:6208/#/login')
    },
    gotoFile(item, num){
      if(num == 1){
        window.open(this.$router.resolve({ path: `/preview?materialId=${item.materialId}&type=${item.suffix}` }).href, '_blank');
      }else{
        this.$router.push('/fileDetails?wid='+item.wid+'&title='+item.name+'&manageId='+this.manageId)
      }
    },
    returnFn(){
      // this.$router.go(-1)
      let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
      naviTop.forEach(item => {
        if(item.link == '/serviceHall'){
          this.$router.push('/serviceHall?naviId='+item.id)
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.serviceDetails {
  position: relative;
  .text-container {
    white-space: pre-line;//使得文本中的换行符（\n）被识别并显示为新的一行
  }
  .banner {
    width: 100%;
    min-height: 17rem;
    background: url("../../assets/banner-red.png") no-repeat center;
    background-size: cover;
    .ban_l {
      flex: 1;
      margin-top: 0;
      width: 65%;
      .tit_p {
        text-align: left;
        // color: #7a8ba4;
        opacity: 0.8;
        margin-bottom: 26px;
        padding-top: 13px;
        img {
          margin: 0 2px 2px 2px;
        }
        span{
          cursor: pointer;
        }
      }
      .tit {
        font-weight: 900;
        font-size: 40px;
        margin-bottom: 1%;
      }
      .desc {
        font-size: 14px;
        // color: #7a8ba4;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .bon_col {
        margin-top: 24px;
        margin-bottom: 24px;
        margin-right: 4%;
        div {
          border-radius: 8px;
          padding: 0.8rem 0.85rem;
          font-size: 18px;
          background: #fff;
          margin-right: 12px;
          cursor: pointer;
          img {
            margin-right: 10px;
          }
        }
        .handle {
          background: var(--themeColor);
          color: #fff;
        }
      }
      .rate {
        font-size: 14px;
        flex: 1;
        span {
          color: #7a8ba4;
        }
        div {
          color: var(--themeColor);
        }
      }
    }
    .ban_r {
      width: 43%;
      height: 272px;
      background: url("../../assets/sevice-red.png") no-repeat right;
      position: absolute;
      top: -4%;
      right: 0%;
    }
  }

  .affix_box{
    width: 100%;
    height: 60px;
    background: #fafafa;
    box-shadow: 9px 5px 7px 0 rgba(0, 0, 0, 0.1);
    .flex{
      z-index: 999;
      justify-content: space-between;
    }
    .tit{
      font-size: 24px;
      font-weight: 600;
    }
    .handle{
      font-size: 16px;
      color: #fff;
      background: var(--themeColor);
      border-radius: 8px;
      padding: 8px 12px;
      cursor: pointer;
    }
  }
  /deep/.ant-affix{
    width: 100% !important;
    z-index: 999 !important;
  }
  
  .anchor_box{
    position: absolute;
    left: 75px;
    // top: 26%;
    top: 330px;
    z-index: 99;
  }
  .table_bg{
    position: absolute;
    left: 0;
    z-index: 1;
    img{
      width: 100%;
      min-height: 655px;
    }
  }
  .table_out {
    // border: 1px solid #e0e5f0;
    // padding: 28px 24px;
    margin-bottom: 8rem;
    position: relative;
    z-index: 99;
    padding-top: 54px;
    .con_tit {
      font-size: 24px;
      font-weight: 700;
      text-align: left;
      margin-right: 12px;
    }
    .file_class{      
      border-radius: 8px;
      border: 1px solid  #E0E5F0;
      padding: 12px;
      justify-content: space-between;
      font-size: 16px;
      margin-bottom: 24px;
      a{
        color: #7A8BA4;
        div{
          margin-right: 8px;
        }
      }
    }
    .table_content{
      margin-bottom: 137px;
      .table_bd {
        border-top: 1px solid #e0e5f0;
        border-left: 1px solid #e0e5f0;
        max-width: 62.5rem;
        overflow: hidden;
        flex: 4;
        .table_line {
          flex-wrap: wrap;
          width: 100%;
          align-content: flex-start;
          .table_box {
            border-bottom: 1px solid #e0e5f0;
            border-right: 1px solid #e0e5f0;
            width: 100%;
          }
          .table_label {
            // background: #ebeffc;
            background: rgba(0, 0, 0, 0.03);
            flex: 2;
            padding: 12px 34px;
          }
          .table_value {
            flex: 7;
            padding: 3px 26px;
            max-height: 49px;
            padding-right: 8px;
            overflow-y: auto;
            text-align: center;
            justify-content: center;
            img{
              width: 18px;
              margin-right: 6px;
            }
          }
        }
      }
      .table_rt{
        margin-left: 103px;
        flex: 2;
        text-align: left;
        .rt_box{
          padding: 24px 32px;
          border: 1px solid #DFE1E2;
          margin-bottom: 24px;
          .rt_title{
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 12px;
          }
          .li_box{
            font-size: 16px;
            margin-bottom: 8px;
            &:last-child{
              margin-bottom: 0;
            }
            img{
              margin-right: 8px;
            }
            .number{
              color: var(--themeSloganColor);
              margin-left: 30px;
              margin-right: 12px;
              font-weight: 700;
            }
          }
        }
        .rt_box:last-child .number{
          margin-left: 46px;
        }
      }
    }
    .img_tag{     
      .img_tag1{
        position: absolute;
        top: -4px;
        right: 15%;
      }
      .img_tag2{
        position: absolute;
        top: -4px;
        right: 26%;
      }
      .img_tag3{
        position: absolute;
        top: -11px;
        right: -1%;
      }
    }
  }

  .tabs{
    margin-bottom: 44px;
    .pres{
      margin-bottom: 24px;
      img{
        max-width: 35.8rem;
      }
    }
    .file{
      text-align: left;
    }
  }
  .step_ul{
    border: 1px solid #E0E5F0;
    padding: 16px;
    margin-top: 24px;
    .step_li{
      margin-left: 34px;
      margin-bottom: 16px;
      .order{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        color: var(--themeColor);
        background: var(--themeColor1);
        font-size: 20px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        margin-bottom: 16px;
      }
      .li_r{
        font-size: 16px;
        margin-left: 16px;
        .li_title{
          margin-bottom: 12px;
          padding: 23px 20px;
          border-radius: 8px;
          box-shadow: 0px 2px 0px 0px rgba(49, 104, 236, 0.40) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
        }
        .remark{
          color: #999;
          padding-left: 20px;
        }
      }
      .flex{
        align-items: normal;
      }
    }
  }
  .precautions{
    margin-top: 66px;
    padding: 24px 20px;
    background: #F8F8F8;
    font-size: 16px;
    color: #7B7B7B;
    text-align: left;
    div:first-child {
      font-weight: 700;
      margin-bottom: 16px;
    }
  }


  .tag_box div{
    font-size: 14px;
    padding: 4px 10px;
    border-radius: 4px;
    margin-right: 8px;
  }
  .green_tag{
    color: #0BD01B;
    background: rgba(11, 208, 27, .1);
  }
  .yellow_tag{
    color: #FF7300;
    background: rgba(255, 115, 0, .1);
  }
  .red_tag{
    color: #F00;
    background: rgba(255, 0, 0, .1);
  }
}
/deep/.ant-anchor-link-active{
  // padding-left: 0;
  background: linear-gradient(90deg, #EBEFFC 0%, rgba(235, 239, 252, 0) 100%);
}
/deep/.ant-anchor-ink-ball{
  width: 0;
  height: 0;
  border: none;
}
</style>
